import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadWeeks, selectCurrent } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import {
  selectPositionsState,
  selectPositionsStatsMap,
  getPositionsStatsMap,
} from '../../../../store/reducers/positions';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'weeklyStats';
export const selectWeeklyStatsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  stats: [],
  year: null,
  position: '',
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const weeklyStatsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default weeklyStatsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_WEEKLY_STATS_REQUEST = `${STORE_KEY}/LOAD_WEEKLY_STATS_REQUEST`;
export const LOAD_WEEKLY_STATS_SUCCESS = `${STORE_KEY}/LOAD_WEEKLY_STATS_SUCCESS`;
export const LOAD_WEEKLY_STATS_ERROR = `${STORE_KEY}/LOAD_WEEKLY_STATS_ERROR`;

export const loadWeeklyStatsRequest = ({ year, formulaId, position, week }) => ({
  type: LOAD_WEEKLY_STATS_REQUEST,
  payload: { year, formulaId, position, week },
});
export const loadWeeklyStatsSuccess = (stats) => ({
  type: LOAD_WEEKLY_STATS_SUCCESS,
  payload: { stats },
});
export const loadWeeklyStatsError = error => ({
  type: LOAD_WEEKLY_STATS_ERROR,
  payload: { error },
});

actions[LOAD_WEEKLY_STATS_REQUEST] = (
  state,
  { payload: { year, formulaId, position, week } },
) => ({ ...state,
  year,
  formulaId,
  position,
  week,
});
actions[LOAD_WEEKLY_STATS_SUCCESS] = (state, { payload: { stats } }) => ({ ...state,
  stats,
  hasLoaded: true,
});
actions[LOAD_WEEKLY_STATS_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadWeeklyStats = ({
  year,
  formulaId,
  position,
  week,
}) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadWeeklyStatsRequest({ year, formulaId, position, week }));
    const [response] = await Promise.all([
      api.stats.getWeeklyForPosition({ year, formulaId, position, week }),
      dispatch(loadWeeks(year)),
    ]);

    dispatch(loadWeeklyStatsSuccess(response.season_position_stats));
  } catch (error) {
    console.error(error);
    dispatch(loadWeeklyStatsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const WEEKLY_STATS_VIEW = `${STORE_KEY}/WEEKLY_STATS_VIEW`;
export const WEEKLY_POSITION_STATS_MAP_KEY = 'player-stats-weekly';
viewNames[WEEKLY_STATS_VIEW] = 'WeeklyStats';
routes[WEEKLY_STATS_VIEW] = {
  path: '/weekly',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, formulaId, week, position } = selectQuery(state);

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = selectCurrent(state, 'stats').season;
    if (!position) position = selectPositionsState(state).stats[0];

    if (typeof week !== 'number') week = selectCurrent(state, 'stats').week;
    let positionsStatsMap = selectPositionsStatsMap(state, WEEKLY_POSITION_STATS_MAP_KEY);
    if (!positionsStatsMap) {
      await dispatch(getPositionsStatsMap(WEEKLY_POSITION_STATS_MAP_KEY));
      positionsStatsMap = selectPositionsStatsMap(getState(), WEEKLY_POSITION_STATS_MAP_KEY);
    }
    // Needs to await otherwise data won't load on SSR
    await dispatch(loadWeeklyStats({ year, formulaId, position, week }));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/WeeklyStats/module/weeklyStats.js